<template>
  <amadeus-booking-url
    :itineraries="[
      {
        fromAirportCode: props.itineraries.fromDestinationCode,
        toAirportCode: props.itineraries.toDestinationCode,
        departureDate: departureDateOne,
      },
      {
        fromAirportCode: props.itineraries.toDestinationCode,
        toAirportCode: props.itineraries.fromDestinationCode,
        departureDate: departureDateTwo,
      },
    ]"
    :passenger-and-cabin-class="{
      Cabin: props.cabinClass,
    }"
  >
    <button :class="props.customClasses" type="submit">
     <slot></slot>
    </button>
  </amadeus-booking-url>
</template>

<script setup>
import { onUpdated, ref } from 'vue';
import AmadeusBookingUrl from '../AmadeusBookingUrl/AmadeusBookingUrl.vue';
import useConvertDate from '../../hooks/useConvertDate';

const departureDateOne = ref('');
const departureDateTwo = ref('');

const props = defineProps({
  routePlanner: {
    type: Boolean,
    default: false,
  },
  customClasses: {
    type: String,
    default: '',
  },
  cabinClass: {
    type: String,
    default: '',
  },
  itineraries: {
    type: Object,
    default: () => {
      return [
        {
          fromAirportCode: '',
          toAirportCode: '',
          departureDate: '',
        },
        {
          fromAirportCode: '',
          toAirportCode: '',
          departureDate: '',
        },
      ];
    },
  },
});

onUpdated(() => {
  const travelDates = props.itineraries.travelDates;

  if (!travelDates) {
    return;
  }

  const separator = travelDates.includes('to') ? 'to' : '-';

  const [departureDateOneStr, departureDateTwoStr] = travelDates
    .split(separator)
    .map((date) => date.trim());

  departureDateOne.value = separator === '-' && departureDateOneStr
    ? useConvertDate(departureDateOneStr)
    : departureDateOneStr;
  
  departureDateTwo.value = separator === '-' && departureDateTwoStr
    ? useConvertDate(departureDateTwoStr)
    : departureDateTwoStr;
});

</script>
